<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center">

          <!-- Título da página -->
          <basic-toolbar :title="'Editar informações do arquivo'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Nome do arquivo -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                      <v-text-field
                        id="nomeArquivo"
                        label="Nome do arquivo"
                        v-model="arquivo.nome"
                        readonly
                       >
                      </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Tipo do arquivo -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-select
                      id="tipoArquivo"
                      label='Tipo do arquivo*'
                      :items="listaTipoArquivo"
                      v-model="arquivo.tipoArquivo"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      return-object
                      autocomplete
                      required
                      :rules="obrigatorio" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <!-- Observação -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-textarea
                      class="observacao"
                      :label="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? 'Observação*' : 'Observação' : 'Observação'"
                      v-model="arquivo.observacao"
                      :rules="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? [...obrigatorio,...max200caracteres] : max200caracteres : max200caracteres"
                      :rows="2"
                      :auto-grow="true"
                      multi-line
                      counter="200"
                      :hint="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? 'Informe o tipo de documento' : false : false"
                      :persistent-hint="arquivo.tipoArquivo !== null ? arquivo.tipoArquivo.item === 3 ? true : false : false"
                     >
                    </v-textarea>
                  </v-flex>
                </v-layout>

              </v-container>

            </v-form>

            <v-divider></v-divider>

            <!-- Botões "Cancelar" e "Salvar" -->
            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Salvar" -->
              <v-btn color="primary" @click="editarArquivo()" :disabled="!formularioValido">Salvar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'idArquivoProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      arquivo: {
        conteudo: {},
        nome: '',
        observacao: '',
        tipoArquivo: null,
        nivelAcesso: 'P'
      },
      listaTipoArquivo: [],
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max200caracteres: [v => v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Função para ordenar lista de tipos de arquivos.
      funcaoOrdenaListaTiposArquivos: function (tipo1, tipo2) {
        return tipo1.item - tipo2.item
      },

      // Redireciona para a tela de visualização da aba "Arquivos" -->
      cancelar: function () {
        this.$router.push({name: 'ProjetoPesquisaArquivos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      },

      // Edita o arquivo.
      editarArquivo () {
        let body = new FormData()
        body.append('nome', this.arquivo.nome)
        body.append('tipoArquivoItem', this.arquivo.tipoArquivo.item)
        body.append('nivelAcesso', this.arquivo.nivelAcesso)
        body.append('observacao', this.arquivo.observacao)
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando informações do arquivo...' })
        projetos.putArquivoProjetoPesquisa(this.idProjetoPesquisa, this.idArquivoProjetoPesquisa, this.arquivo)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaArquivos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando informações do arquivo...' })
        })
      },

      // Carrega tabela estruturada.
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
          aqui[atributo].sort(this.funcaoOrdenaListaTiposArquivos)
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando tipos de arquivo...' })
        })
      }
    },
    mounted () {
      // Carrega lista com os tipos de arquivos (COD_TABELA = 1170).
      this.opcoesTabelaEstruturada(1170, this, 'listaTipoArquivo')

      // Carrega as informações do arquivo.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo...' })
      projetos.getArquivoProjetoPesquisa(this.idProjetoPesquisa, this.idArquivoProjetoPesquisa)
      .then(response => {
        this.arquivo = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações do arquivo...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>

<style scoped>

  #nomeArquivo {
    margin-top: 3em;
  }

  #tipoArquivo {
    margin-top: 2em;
  }

  .observacao {
    margin-bottom: 2.0em;
  }

</style>



// WEBPACK FOOTER //
// editar-arquivo.vue?0e81e8cf